import {createRootRouteWithContext} from "@tanstack/react-router";
import {setGlobalTheme} from "@atlaskit/tokens";
import {AllEnterpriseModule, ModuleRegistry} from "ag-grid-enterprise";
// TODO: Importing this is reseting all our tailwind styles, so we're not importing it for now. Fix this.
// import "@atlaskit/css-reset";
import "~/styles/tailwind.css";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import type {IntellsysRouterContext} from "~/boilerplate/application";
import {ANANKE__PREFERENCES__QUERY_KEY} from "~/utilities/queryKeys";
import {anankePreferencesZodValidator, defaultAnankePreferences, type AnankePreferences} from "@vesta/ananke/domainModels/anankeConfiguration";
import {jsonZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

ModuleRegistry.registerModules([AllEnterpriseModule]);

export const Route = createRootRouteWithContext<IntellsysRouterContext>()({
    beforeLoad: async ({context}) => {
        console.log(Route.id, "beforeLoad", "start");
        // await delay(5000);
        const anankePreferences = await context.queryClient.ensureQueryData<AnankePreferences>({
            queryKey: [ANANKE__PREFERENCES__QUERY_KEY],
            queryFn: async () => {
                const anankePreferencesResult = jsonZodValidator
                    .pipe(anankePreferencesZodValidator)
                    .safeParse(localStorage.getItem("ananke"));
                let anankePreferences: AnankePreferences;
                if (anankePreferencesResult.success === true) {
                    anankePreferences = anankePreferencesResult.data;
                } else {
                    anankePreferences = defaultAnankePreferences;
                }

                // TODO: Figure out whether I should do this here, or in component
                setGlobalTheme({colorMode: anankePreferences.theme});
                // TODO: Set bg/color on html tag as well

                return anankePreferences;
            },
            retry: false,
            staleTime: Infinity,
        });

        console.log(Route.id, "beforeLoad", "end");
        return {
            anankePreferences: anankePreferences,
            //
        };
    },
    loader: async ({context}) => {
        return {
            // hadesBaseUrl: context.hadesBaseUrl,
            intellsysBaseUrl: context.intellsysBaseUrl,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    notFoundComponent: NotFoundComponent,
    pendingComponent: PendingComponent,
});
